export default __webpack_public_path__ + "static/media/asset-meteor-biru.3d62946c.png";